export default __webpack_public_path__ + "static/media/Ritik Tiwari.334a31a8.png";